import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["limit", "sheetContainerType"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { VersionSetItem } from '../models';
import { DateUtil } from '../utils';
import { CANCEL_KEYS, SHEETS_CONTAINER_TYPES } from '../utils/consts';

/**
 * `Service` The version sets service, is used to creed versionSet related data.
 */
var VersionSets = /*#__PURE__*/function (_Base) {
  /**
   * Create the versionSets service instance.
   *
   * @param sdk - the SDK instance
   */
  function VersionSets(sdk) {
    _classCallCheck(this, VersionSets);
    return _callSuper(this, VersionSets, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(VersionSets, _Base);
  return _createClass(VersionSets, [{
    key: "getVersionSet",
    value: (
    /**
     * Get the version set in project.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/7d2a9c9a003df-get-a-version-set
     *
     * @param projectId - the project uuid
     * @param setId - the set uuid
     * @param params - query parameters with shape of `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that shape of a version set object
     */
    function () {
      var _getVersionSet = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, setId, config, params) {
        var query, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              _context.next = 3;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/version-sets/").concat(setId).concat(query), config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data ? VersionSetItem.parseV3(response.data) : null);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getVersionSet(_x, _x2, _x3, _x4) {
        return _getVersionSet.apply(this, arguments);
      }
      return getVersionSet;
    }()
    /**
     * Get the version sets in project.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/e81e8371b81e7-list-version-sets
     *
     * @param projectId - the project uuid
     * @param params - query parameters with shape of `offset`, `limit`, `sort`, `collectionId`, `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that shape of `pagination`, `currentSetCount`, `results`
     */
    )
  }, {
    key: "getVersionSets",
    value: (function () {
      var _getVersionSets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, params, config) {
        var _this = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this.loadVersionSetsCancelToken;
                },
                setter: function setter(token) {
                  return _this.loadVersionSetsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.loadVersionSetsCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/version-sets").concat(query);
              _context2.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context2.sent;
              if (!response.data) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", {
                pagination: response.data.pagination || {},
                versionSets: (response.data.results || []).map(VersionSetItem.parseV3)
              });
            case 8:
              return _context2.abrupt("return", null);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getVersionSets(_x5, _x6, _x7) {
        return _getVersionSets.apply(this, arguments);
      }
      return getVersionSets;
    }()
    /**
     * Get the version sets of all pages one time in project.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/e81e8371b81e7-list-version-sets
     *
     * @param projectId - the project uuid
     * @param params - query parameters with shape of `limit`, `sort`, `collectionId`, `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise of version sets list
     */
    )
  }, {
    key: "getAllVersionSets",
    value: (function () {
      var _getAllVersionSets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, params, config) {
        var _this2 = this;
        var conf, offset, hasNextPage, result, _ref, _ref$limit, limit, _ref$sheetContainerTy, sheetContainerType, rest, _response$data, _response$data2, query, url, response, _response$data$pagina, totalResults;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.loadAllVersionSetsCancelToken;
                },
                setter: function setter(token) {
                  return _this2.loadAllVersionSetsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.loadAllVersionSetsCancelToken = undefined;
                }
              }), config);
              offset = 0;
              hasNextPage = true;
              result = [];
              _ref = params || {}, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 1000 : _ref$limit, _ref$sheetContainerTy = _ref.sheetContainerType, sheetContainerType = _ref$sheetContainerTy === void 0 ? SHEETS_CONTAINER_TYPES.BUILD : _ref$sheetContainerTy, rest = _objectWithoutProperties(_ref, _excluded);
            case 5:
              if (!hasNextPage) {
                _context3.next = 14;
                break;
              }
              query = QS.stringify(_extends({
                sheetContainerType: sheetContainerType,
                limit: limit
              }, rest, {
                offset: offset
              }), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/version-sets").concat(query);
              _context3.next = 10;
              return this.HttpService.dmV3.get(url, conf);
            case 10:
              response = _context3.sent;
              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.results && response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.pagination) {
                result = [].concat(_toConsumableArray(result), _toConsumableArray(response.data.results.map(VersionSetItem.parseV3)));
                offset = offset + limit;
                _response$data$pagina = response.data.pagination.totalResults, totalResults = _response$data$pagina === void 0 ? 0 : _response$data$pagina;
                if (offset >= totalResults) hasNextPage = false;
              } else {
                hasNextPage = false;
              }
              _context3.next = 5;
              break;
            case 14:
              return _context3.abrupt("return", result);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAllVersionSets(_x8, _x9, _x10) {
        return _getAllVersionSets.apply(this, arguments);
      }
      return getAllVersionSets;
    }()
    /**
     * Create a new version set.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/5f57d5ec59dcd-create-a-version-set
     *
     * @param projectId - the project uuid
     *
     * @param payload - request payload with shape of `name`, `issuanceDate` and `collectionId`
     * @param params - query parameters with shape of `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that shape of a version set object
     */
    )
  }, {
    key: "createVersionSet",
    value: (function () {
      var _createVersionSet = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, payload, config, params) {
        var query, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              _context4.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/version-sets").concat(query), _extends({}, payload, {
                issuanceDate: DateUtil.trimTimezoneAndToUTC(payload === null || payload === void 0 ? void 0 : payload.issuanceDate)
              }), config);
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.data ? VersionSetItem.parseV3(response.data) : null);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createVersionSet(_x11, _x12, _x13, _x14) {
        return _createVersionSet.apply(this, arguments);
      }
      return createVersionSet;
    }()
    /**
     * Edit an existing version set.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/362ab62695f70-update-a-version-set
     *
     * @param projectId - the project uuid
     * @param setId - the set uuid
     * @param payload - request payload with shape of `name` and `issuanceDate`
     * @param params - query parameters with shape of `useExactTime`, `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that shape of a version set object
     */
    )
  }, {
    key: "updateVersionSet",
    value: (function () {
      var _updateVersionSet = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, setId, payload, params, config) {
        var data, query, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              data = payload.issuanceDate ? _extends({}, payload, {
                issuanceDate: DateUtil.trimTimezoneAndToUTC(payload.issuanceDate)
              }) : payload;
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              _context5.next = 4;
              return this.HttpService.dmV3.patch("/projects/".concat(projectId, "/version-sets/").concat(setId).concat(query), data, config);
            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data ? VersionSetItem.parseV3(response.data) : null);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateVersionSet(_x15, _x16, _x17, _x18, _x19) {
        return _updateVersionSet.apply(this, arguments);
      }
      return updateVersionSet;
    }()
    /**
     * Delete version sets.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/1f986bc874916-delete-version-sets
     *
     * @param projectId - the project uuid
     * @param payload - id list of version set to delete
     * @param params - query parameters with shape of `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with no content
     */
    )
  }, {
    key: "deleteVersionSets",
    value: (function () {
      var _deleteVersionSets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, payload, config, params) {
        var query;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              _context6.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/version-sets:batch-delete").concat(query), payload, config);
            case 3:
              return _context6.abrupt("return", _context6.sent);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function deleteVersionSets(_x20, _x21, _x22, _x23) {
        return _deleteVersionSets.apply(this, arguments);
      }
      return deleteVersionSets;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'VersionSets';
    }
  }]);
}(Base);
export default VersionSets;